import { useTranslation } from 'react-i18next';
import { Chip, Popover } from '@c2fo/liquidity';
import InstantPayStatusChip from '@/enterprise/components/InstantPay/InstantPayStatusChip';

interface ClearStatusChipProps {
  isPendingClear: boolean;
  isInstantPay?: boolean;
  /** Turn off inside an interactive element (a link row), where clicking must reach the parent. */
  withTooltip?: boolean;
}

const ClearStatusChip = ({ isPendingClear, isInstantPay, withTooltip = true }: ClearStatusChipProps) => {
  const { t } = useTranslation();

  if (isInstantPay) {
    return <InstantPayStatusChip withTooltip={withTooltip} />;
  }

  const chip = (
    <Chip
      size="xs"
      type={isPendingClear ? 'default' : 'primary'}
      label={isPendingClear ? t('core.history.statusPending') : t('core.history.statusAwarded')}
      isRound
      variant="outlined"
    />
  );

  if (!withTooltip) {
    return chip;
  }

  return (
    <Popover>
      <Popover.Trigger>{chip}</Popover.Trigger>
      <Popover.Content arrow side="right">
        <div className="w-52 text-center text-sm">
          {isPendingClear ? t('taker.history.statusPendingTooltip') : t('taker.history.statusAwardedTooltip')}
        </div>
      </Popover.Content>
    </Popover>
  );
};

export default ClearStatusChip;
